import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
    name: "header-ai-assistant",
    template: require("./template.html"),
})
export default class AIAssistantButton extends Vue {
    @Prop({ type: Boolean, default: false }) isActive!: boolean;
}
